module.exports = __webpack_public_path__ + "static/travelzik-f92e4c88b91c162f528f6e66847507f7.png";